import React from 'react';
import { Box, Container, SimpleGrid, Text } from '@chakra-ui/react';
import { Wallet, Users, Building2, TrendingUp } from 'lucide-react';
import StatCard from '../ui/StatCard';

const StatsSection = () => {
  const stats = [
    { icon: Wallet, value: '$19M+', label: 'Total Invested' },
    { icon: Users, value: '1,800+', label: 'Happy Investors' },
    { icon: Building2, value: '20+', label: 'Properties Managed' },
    { icon: TrendingUp, value: '14.5%', label: 'Blended Portfolio Yield*' },
  ];

  return (
    <Box as="section" pt={{ base: 2, md: 3 }} pb={{ base: 8, md: 9 }} bg="#071326">
      <Container maxW="container.xl" px={{ base: 5, md: 8 }} position="relative" zIndex={2}>
        <Box
          bg="rgba(10,27,52,0.78)"
          border="1px solid"
          borderColor="rgba(255,255,255,0.10)"
          borderRadius="8px"
          px={{ base: 5, md: 8 }}
          py={{ base: 5, md: 6 }}
          boxShadow="0 12px 34px rgba(0,0,0,0.28)"
        >
          <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing={{ base: 6, md: 6, lg: 8 }}>
            {stats.map((stat) => (
              <StatCard
                key={stat.label}
                value={stat.value}
                label={stat.label}
                icon={stat.icon}
              />
            ))}
          </SimpleGrid>
          <Text
            mt={5}
            textAlign={{ base: 'left', lg: 'right' }}
            fontFamily="body"
            fontSize="xs"
            color="#9AA7B8"
            maxW={{ base: 'full', lg: '420px' }}
            ml={{ lg: 'auto' }}
            lineHeight={1.6}
          >
            *Historical average across completed investments.
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default StatsSection;
